export default "__VITE_ASSET__405136ca__"